import { render } from "./CouponList.vue?vue&type=template&id=37bb02ae&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"

import "./CouponList.vue?vue&type=style&index=0&id=37bb02ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bb02ae"]])

export default __exports__